import type { FilterConfigInterface } from "~/modules/catalog/category/config/FiltersConfig";

export enum FilterTypeEnum {
	RADIO = "radio",
	CHECKBOX = "checkbox",
	SWATCH_COLOR = "swatch_color",
	YES_NO = "yes_no",
}

/**
 * Override this to add/modify filters renderers and data
 *
 * @attrCode: Magento attribute code
 * @type: internal filter type
 * @component: filter renderer component
 * @disabled: flag to disable filter on the front; disabled filter will be not rendered
 */
export default function config(): FilterConfigInterface[] {
	return [
		{
			attrCode: "is_new_product",
		},
		{
			attrCode: "flag_promo",
		},
		{
			attrCode: "paint_recommended_uses",
		},
		{
			attrCode: "facet_product_type",
		},
		{
			attrCode: "paint_usage",
		},
		{
			attrCode: "facet_paints_finish_level",
		},
		{
			attrCode: "facet_paint_destination",
		},
		{
			attrCode: "appearance",
		},
		{
			attrCode: "use_interior_exterior",
		},
		{
			attrCode: "product_water_solvant",
		},
		{
			attrCode: "family_product_by_trade",
		},
		{
			attrCode: "facet_all_product_type",
		},
		{
			attrCode: "destination_room",
		},
		{
			attrCode: "product_target",
		},
		{
			attrCode: "distribution_brand",
		},
		{
			attrCode: "pattern",
		},
		{
			attrCode: "color_family",
		},
		{
			attrCode: "wallpaper_washability",
		},
		{
			attrCode: "wet_room_compatible",
		},
		{
			attrCode: "format_type",
		},
		{
			attrCode: "traffic",
		},
		{
			attrCode: "chamfer",
		},
		{
			attrCode: "installation_type",
		},
		{
			attrCode: "brush_type",
		},
		{
			attrCode: "water_solvant_based_paint",
		},
		{
			attrCode: "roller_type",
		},
		{
			attrCode: "rollers_appearance",
		},
		{
			attrCode: "roller_size",
		},
		{
			attrCode: "plasters_use",
		},
		{
			attrCode: "texture",
		},
		{
			attrCode: "color_workwear_footwear_ppe",
		},
		{
			attrCode: "workwear_size",
		},
		{
			attrCode: "abrasive_type",
		},
		/*{
      attrCode: 'new',
      type: FilterTypeEnum.YES_NO,
      component: RendererTypesEnum.YES_NO,
    },*/
	];
}
